import {ArtAufteilungEnum} from '../v2024';

export const ArtAufteilungEnumLabels = {
    NachGezeichnetemKapital: '1' as ArtAufteilungEnum,
    NachBruchteilen: '2' as ArtAufteilungEnum,
    NachEingezahltemKapital: '3' as ArtAufteilungEnum,
    AndererAufteilungsschluessel: '0' as ArtAufteilungEnum
};
